export const LANGUAGE_PROFICIENCY_LEVEL_MAPPING = {
    0: 'unspecified',
    1: 'basic',
    2: 'conversational',
    3: 'fluent',
    4: 'native_or_bilingual',
};

/**
 * Initial value of reminder interval key
 *
 * @type {number}
 */
export const INITIAL_REMINDER_INTERVAL_KEY = 1;

/**
 * The interval milliseconds for each the button would be reanimated.
 *
 * @type {number}
 */
export const REMINDER_INTERVAL_MS = 30000;
